import React from 'react';

const Contact = () => (
  <section id="contact" className="container my-5">
    <div className="card shadow-sm p-4">
      <h2 className="mb-3">Contact</h2>
      <p>Have questions or suggestions? Reach out to us and we'll be happy to help you on your full stack journey!</p>
    </div>
  </section>
);

export default Contact; 